/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import EunoiaInput from '../TextInput/TextInput';
import styles from './RangoArrayInput.module.scss';

interface RangoArrayInputProps {
  id: string;
  name: string;
  path: string;
  label?: string;
  placeholder?: string;
  value?: number[];
  className?: string;
  onChange?: (path: string, value: number[]) => void;
}

const RangoArrayInput = (props: RangoArrayInputProps): JSX.Element => {
  const { id, name, path, label, placeholder, value = [], className = '', onChange } = props;
  const [localValue, setLocalValue] = useState<string>(value.join(', '));
  const lastParsedRef = useRef<string>(value.join(', '));

  useEffect(() => {
    const parsed = Array.isArray(value) ? value.join(', ') : '';
    if (parsed !== lastParsedRef.current) {
      lastParsedRef.current = parsed;
      setLocalValue(parsed);
    }
  }, [value]);

  const handleInputChange = (incomingPath: string, inputValue: string) => {
    setLocalValue(inputValue);

    const parsed = inputValue
      .split(',')
      .map((v) => parseInt(v.trim(), 10))
      .filter((n) => !Number.isNaN(n));

    // Detectar si termina en coma (usuario ha cerrado un valor)
    const endsInComma = /,\s*$/.test(inputValue);
    const lastRawValue = inputValue.split(',').pop()?.trim() || '';
    const isTypingNewNumber = /^\d+$/.test(lastRawValue); // último token parece número

    // Solo disparamos si termina en coma (usuario cerró un valor)
    // o si está escribiendo un número nuevo (no necesitamos doble coma)
    if ((endsInComma || isTypingNewNumber) && parsed.length > 0) {
      onChange?.(incomingPath, parsed);
    }
  };

  return (
    <div className={cx(styles.root, className)}>
      {label && <label htmlFor={id}>{label}</label>}
      <EunoiaInput
        type="text"
        id={id}
        path={path}
        name={name}
        placeholder={placeholder}
        value={localValue}
        onChange={(inputPath: string, inputValue: string) => handleInputChange(inputPath, inputValue)}
      />
    </div>
  );
};

export default RangoArrayInput;
